import { h } from 'preact';
import SVGWrapper from '../../SvgWrapper';

function HeartActiveIcon({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path d="m11.8654 4.83271c-2.13684-2.13682-5.60132-2.13682-7.73814 0-2.28048 2.28048-2.10331 6.02939.2779 8.20439.1221.1116.24483.2241.36792.3376 1.37093 1.2636 1.074.9 3.45 3.3 1.33281 1.3463 2.62422 2.9823 3.31522 3.8929.254.3346.7703.3262 1.0166-.0142.6621-.9148 1.915-2.5443 3.3362-3.8787 2.556-2.4 1.0321-.9 3.444-3.3.0914-.0909.1829-.1811.2743-.2705 2.3199-2.2672 2.5847-6.06335.291-8.35702-2.0895-2.08958-5.4774-2.08958-7.567 0l-.2768.27677z" fill={color} />
    </SVGWrapper>
  );
}

export default HeartActiveIcon;
